import { URL_STATE } from './constants'

const selectData = (state) => state.resolutioncenter.list.data
const selectLoader = (state) => state.resolutioncenter.list.loader
const selectError = (state) => state.resolutioncenter.list.error

const selectReports = (state) => state.resolutioncenter.list.data.reports.results
const selectSelectedReportId = (state) =>
  state.resolutioncenter.list.selectedReportId || selectReports(state)[0]?.id || null
const selectSelectedReportType = (state) =>
  state.resolutioncenter.list.selectedReportType || selectReports(state)[0]?.reportType || null

const selectUrlState = (state) => state.resolutioncenter.list.urlState

const isOnUnclassifed = (state) =>
  !!state.resolutioncenter && selectUrlState(state) === URL_STATE.UNCLASSIFIED

const selectPage = (state) => state.resolutioncenter.list.page

const selectFirstPageLoadDate = (state) => state.resolutioncenter.list.firstPageLoadDate
const selectLastRowDate = (state) => state.resolutioncenter.list.lastRowDate

export {
  selectData,
  selectLoader,
  selectError,
  selectSelectedReportId,
  selectSelectedReportType,
  selectUrlState,
  isOnUnclassifed,
  selectPage,
  selectFirstPageLoadDate,
  selectLastRowDate,
}
